import {
  FundSheetModel,
  type ProjectModel,
  ReviewSheetModel,
  SegmentSheetModel,
} from '@/features/project/projects/_models/project';
import type { FC } from 'react';
import type { z } from 'zod';
import { KsInvestmentProjectInformation } from './KsInvestmentProjectInformation';
import { KsLocalGovernmentProjectInformation } from './KsLocalGovernmentProjectInformation';
import { KsStandardProjectInformation } from './KsStandardProjectInformation';
import { RsProjectInformation } from './RsProjectInformation';
import { RsSkippedReviewProjectInformation } from './RsSkippedReviewProjectInformation';
import { SsProjectInformation } from './SsProjectInformation';

type Props = z.infer<typeof ProjectModel> & {
  historySavedAt: string | undefined | null;
};

const parsedProps = (props: Props) => {
  switch (props.sheetType) {
    case 'RS':
      return ReviewSheetModel.parse(props);
    case 'SS':
      return SegmentSheetModel.parse(props);
    case 'KS':
      return FundSheetModel.parse(props);
    default:
      return props as any;
  }
};

export const ProjectInformation: FC<Props> = (props) => {
  const projectData = {
    ...parsedProps(props),
    historySavedAt: props.historySavedAt,
  };
  switch (projectData.sheetType) {
    case 'RS':
      return projectData.skipAdministrativeReformTeamEvaluation ? (
        <RsSkippedReviewProjectInformation {...projectData} />
      ) : (
        <RsProjectInformation {...projectData} />
      );

    case 'SS':
      return <SsProjectInformation {...projectData} />;

    case 'KS':
      switch (projectData.fundAdditionalAttributes?.fundSheetType) {
        case 'standard':
          return <KsStandardProjectInformation {...projectData} />;

        case 'local-government':
          return <KsLocalGovernmentProjectInformation {...projectData} />;

        case 'investment':
          return <KsInvestmentProjectInformation {...projectData} />;

        default:
          return null;
      }

    default:
      return null;
  }
};
